import type { ComponentSchema } from "../../../../../schema-types"
import { SUPPORTED_PAGES } from '../../_builder-constants'

export const schema: ComponentSchema = {
  type: 'mobileBottomNav',
  label: 'Mobile Navigation',
  description: 'Bottom navigation bar for mobile devices.',
  supportedPages: [...SUPPORTED_PAGES],
  variants: [{ id: 'v1', label: 'V1 (Default)' }],
  commonFields: [
    { key: 'active', label: 'Show Bottom Nav', type: 'boolean' },
    {
      key: 'items',
      label: 'Nav Items',
      type: 'array',
      itemSchema: [
        { key: 'label', label: 'Label', type: 'string' },
        {
          key: 'icon',
          label: 'Icon Type',
          type: 'select',
          options: [
            { label: 'Home', value: 'home' },
            { label: 'Shop (Bag)', value: 'shop' },
            { label: 'Search', value: 'search' },
            { label: 'Cart', value: 'cart' },
            { label: 'User / Account', value: 'account' },
            { label: 'Heart / Wishlist', value: 'heart' },
            { label: 'Chat (WhatsApp)', value: 'chat' },
            { label: 'Menu / Hamburger', value: 'menu' },
            { label: 'Plus / Create', value: 'plus' },
          ],
        },
        {
          key: 'actionType',
          label: 'Action Type',
          type: 'select',
          options: [
            { label: 'Link (Direct URL)', value: 'link' },
            { label: 'Open Search Drawer', value: 'search' },
            { label: 'Open Categories Sidebar', value: 'categories' },
          ],
        },
        { key: 'href', label: 'Target URL', type: 'string' },
        { key: 'isPrimary', label: 'Highlight as Primary (Middle)', type: 'boolean' },
      ],
    },
  ],
}
